<template>
  <el-menu
    :default-active="1"
    class="el-menu-demo"
    mode="horizontal"
    background-color="#545c64"
    text-color="#fff"
    active-text-color="#ffd04b"
  >
    <el-menu-item index="1" @click="redirect('home')">
      <i class="el-icon-s-data"></i>
      <span>Gráficos</span>
    </el-menu-item>
    <el-menu-item index="2" @click="redirect('table')">
      <i class="el-icon-menu"></i>
      <span>Lista</span>
    </el-menu-item>
  </el-menu>
</template>
<script>
export default {
  name: "PostSroMenu",
  computed: {
    size() {
      return `${this.width}px`;
    },
  },
  data() {
    return {
      activeIndex: "1",
      width: 70,
      collapse: true,
    };
  },
  methods: {
    redirect(page) {
      this.$emit("redirect", page);
    },
    resize() {
      this.collapse = !this.collapse;
      this.width = this.collapse ? 70 : 170;
    },
  },
};
</script>
